export const linkStyles = {
	verticalAlign: 'inherit',
};
